// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"234a0a71","453":"8cfdb06f","667":"04693e98"}[chunkId] + ".chunk.js";
};